<template>
   <v-app id="example-2" standalone>
    <v-navigation-drawer
      temporary
      v-model="drawer"
      :mini-variant.sync="mini"
      light
      overflow
      absolute
      v-if="islogin"
    >
      <v-list class="pa-0">
        <v-list-tile avatar tag="div">
          <v-list-tile-avatar>
            <img src="https://randomuser.me/api/portraits/men/85.jpg" />
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>Distribuidora Emanuel</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-btn icon dark @click.native.stop="mini = !mini">
              <v-icon>chevron_left</v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
      <v-list class="pt-0" dense>
        <v-divider></v-divider>
        <v-flex><span>{{usuario}}</span></v-flex>
        <v-list-tile v-for="item in items" :key="item.title" :to="item.url">
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content >
            <v-list-tile-title >{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-btn flat @click="logout" success>Cerrar sesion</v-btn>

    </v-navigation-drawer>
    <v-toolbar  class="primary" dark v-if="islogin">
      <v-toolbar-side-icon @click.native.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title><v-btn flat dark to="/">Distribuidora Emanuel</v-btn></v-toolbar-title>
      <v-flex><span>{{usuario}}</span></v-flex>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-xs-only" v-show="tipo === 'admin' | tipo === 'secretaria'">
         <v-btn flat dark to="/factura">Factura</v-btn>
         <v-btn flat dark to="/buscador">Buscador</v-btn>
         <v-btn flat dark to="/clientes">Clientes</v-btn>
         <v-btn flat dark to="/reportes">Reportes</v-btn>
         <v-btn flat dark to="/kilometraje">Kilometraje</v-btn>
         <v-btn flat dark to="/kilometrajevendedor">Kilometraje Vendedor</v-btn>
         <v-btn flat dark to="/anularfacturas">Anular Facturas</v-btn>
         <v-btn flat dark to="/cotizacion">Cotización</v-btn>
         <v-btn flat dark to="/compratemporal">Compra</v-btn>
         <v-btn flat dark to="/devoluciones">Devoluciones</v-btn>
        <v-spacer></v-spacer>
      </v-toolbar-items>
      <v-toolbar-items class="hidden-xs-only" v-show="tipo === 'gerente' | tipo === 'bodeguero'">
         <v-btn flat dark to="/factura">Factura</v-btn>
         <v-btn flat dark to="/buscador">Buscador</v-btn>
         <v-btn flat dark to="/compratemporal">Compra</v-btn>
         <v-btn flat dark to="/devoluciones">Devoluciones</v-btn>
        <v-spacer></v-spacer>
      </v-toolbar-items>
      <v-toolbar-items class="hidden-xs-only" v-show="tipo === 'vendedor'">
         <v-btn flat dark to="/factura">Factura</v-btn>
         <v-btn flat dark to="/clientes">Clientes</v-btn>
         <v-btn flat dark to="/reporteventas">Reportes de ventas</v-btn>
         <v-btn flat dark to="/extraccion">Extraer</v-btn>
         <v-btn flat dark to="/cuadrar">Cuadrar</v-btn>
        <v-btn flat dark to="/kilometrajevendedor">Kilometraje Vendedor</v-btn>
        <v-spacer></v-spacer>
      </v-toolbar-items>
      <v-toolbar-items class="hidden-xs-only" v-show="tipo === 'chofer'">
         <v-btn flat dark to="/kilometraje">Kilometraje</v-btn>
         <v-btn flat dark to="/anularfacturas">Anular Facturas</v-btn>
         <v-btn flat dark to="/devoluciones">Devoluciones</v-btn>
        <v-spacer></v-spacer>
      </v-toolbar-items>
      <v-btn flat dark @click="logout" class="hidden-xs-only">Cerrar sesion</v-btn>
    </v-toolbar>
    <main>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </main>
  </v-app>
</template>

<script>
  export default {
    created () {
      this.$store.commit('actualizartipo', localStorage.getItem('tipo'))
    },
    data () {
      return {
        drawer: null,
        mini: false,
        right: true
      }
    },
    methods: {
      logout () {
        this.$store.dispatch('logout')
      }
    },
    computed: {
      islogin: function () {
        return this.$store.getters.is_authenticated || localStorage.getItem('token')
      },
      usuario: function () {
        return localStorage.getItem('usuario')
      },
      tipo: function () {
        return this.$store.getters.gettipo
      },
      items: function () {
        if (this.$store.getters.gettipo === 'admin' || this.$store.getters.gettipo === 'secretaria') {
          return [
            { title: 'Factura', icon: 'add_shopping_cart', url: 'factura' },
            { title: 'Clientes', icon: 'account_circle', url: 'clientes' },
            { title: 'Reportes', icon: 'file', url: 'reportes' },
            { title: 'Reportes de Ventas', icon: 'file', url: 'reporteventas' },
            { title: 'Kilometraje', icon: 'add_shopping_cart', url: 'kilometraje' },
            { title: 'Anular Factura', icon: 'add_shopping_cart', url: 'anularfacturas' },
            { title: 'Cotizacion', icon: 'add_shopping_cart', url: 'cotizacion' },
            { title: 'Buscador', icon: 'search', url: 'buscador' },
            { title: 'Extraer', icon: 'money', url: 'extraccion' },
            { title: 'Cuadrar', icon: 'money', url: 'cuadrar' },
            { title: 'Compra', icon: 'money', url: 'compratemporal' },
            { title: 'Devoluciones', icon: 'money', url: 'devoluciones' }
          ]
        } else if (this.$store.getters.gettipo === 'gerente' || this.$store.getters.gettipo === 'bodeguero') {
          return [
            { title: 'Factura', icon: 'add_shopping_cart', url: 'factura' },
            { title: 'Buscador', icon: 'search', url: 'buscador' },
            { title: 'Compra', icon: 'money', url: 'compratemporal' },
            { title: 'Devoluciones', icon: 'money', url: 'devoluciones' }
          ]
        } else if (this.$store.getters.gettipo === 'vendedor') {
          return [
            { title: 'Factura', icon: 'add_shopping_cart', url: 'factura' },
            { title: 'Clientes', icon: 'account_circle', url: 'clientes' },
            { title: 'Reportes de Ventas', icon: 'file', url: 'reporteventas' },
            { title: 'Buscador', icon: 'search', url: 'buscador' },
            { title: 'Extraer', icon: 'money', url: 'extraccion' },
            { title: 'Kilometraje Vendedor', icon: 'add_shopping_cart', url: 'kilometrajevendedor' }
          ]
        } else if (this.$store.getters.gettipo === 'chofer') {
          return [
            { title: 'Kilometraje', icon: 'add_shopping_cart', url: 'kilometraje' },
            { title: 'Anular Factura', icon: 'add_shopping_cart', url: 'anularfacturas' },
            { title: 'Devoluciones', icon: 'money', url: 'devoluciones' }
          ]
        }
      }
    }
  }
</script>

<style lang="stylus">
  @import './stylus/main'
  @import './stylus/print'
</style>



// WEBPACK FOOTER //
// App.vue?15f7d204